import { useCallback, useEffect, useState } from "react";
import useLocalStorage from "./useLocalStorage";
import { useWindow } from "./useWindow";
import useDetectCurrentCulture from "./useDetectCurrentCulture";
const useTranslations = () => {
    const { getItem } = useLocalStorage();
    const { culture, defaultCulture } = useDetectCurrentCulture();
    const myWindow = useWindow();
    const [translations, setTranslations] = useState(undefined);
    // wrap resource strings with tag $BDO.LiveSite.String
    const tag = "$$";
    const header = "BDO.LiveSite";
    const isResourceString = (rawString) => rawString && rawString.startsWith(header);
    const wrapWithTag = (resourceString) => `${tag}${resourceString}${tag}`;
    const handleStorageTranslations = () => {
        const localizations = getItem("localizations");
        localizations && setTranslations(localizations.translations);
    };
    useEffect(() => {
        handleStorageTranslations();
    }, []);
    useEffect(() => {
        const sub = myWindow && myWindow.addEventListener("storage", handleStorageTranslations);
        return () => sub;
    }, [myWindow]);
    const t = useCallback((key) => {
        var _a, _b, _c, _d;
        const wrappedKey = wrapWithTag(key);
        const defaultKey = isResourceString(key) ? wrappedKey : key;
        if (!translations) {
            return defaultKey;
        }
        return (_d = (_b = (_a = translations === null || translations === void 0 ? void 0 : translations[culture]) === null || _a === void 0 ? void 0 : _a[key]) !== null && _b !== void 0 ? _b : (_c = translations === null || translations === void 0 ? void 0 : translations[defaultCulture]) === null || _c === void 0 ? void 0 : _c[key]) !== null && _d !== void 0 ? _d : defaultKey;
    }, [translations, culture]);
    return {
        t,
        translations
    };
};
export default useTranslations;
